import { defineBoot } from "#q-app/wrappers";
import { abilitiesPlugin } from "@casl/vue";
import { buildAbility } from "src/services/AppAbility";
import { ref } from "vue";

const ability = buildAbility([]);

/*
  Vue and CASL seem to not always play nice together,
  resulting in CASL return false for every $can call,
  effectively hiding the whole menu in MES.

  ($can returns whether a user group may see a page, etc.)

  This issue may be caused after an AWS token refresh, 
  and Vue doing a complete re-render of the component tree.

  During refresh the CASL ability instance is renewed,
  but perhaps lost track of by CASL.

  This version counter can be used to trigger Vue re-renders.
*/
export const abilityVersion = ref(0);

export default defineBoot(({ app } /* { app, router, ... } */) => {
  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  });
});

export { ability };
